import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const reveal = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.7
  }
};
export function Approach() {
  const {
    lang
  } = useLanguage();
  const isFR = lang === 'FR';
  return <section className="bg-white border-t border-[#E4E6EC] py-28 lg:py-36 px-6" data-id="element-49">
      {/* Header */}
      <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-50">
        <motion.div {...reveal} className="font-sans text-xs font-semibold tracking-[0.2em] text-[#4F46E5] uppercase mb-8" data-id="element-51">
          {isFR ? 'Notre approche' : 'Our approach'}
        </motion.div>
        <motion.h2 {...reveal} transition={{
        duration: 0.7,
        delay: 0.05
      }} className="font-serif text-4xl md:text-5xl lg:text-[3.25rem] text-[#121212] leading-[1.12] tracking-tight mb-6" data-id="element-52">
          {isFR ? <>
              Chaque interaction.
              <br data-id="element-53" />
              Une fondation de <span className="text-[#4F46E5]" data-id="element-54">confiance</span>
              .
            </> : <>
              Every interaction.
              <br data-id="element-55" />
              One <span className="text-[#4F46E5]" data-id="element-56">trusted</span> foundation.
            </>}
        </motion.h2>
        <motion.p {...reveal} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-sans text-lg md:text-xl text-[#121212]/60 leading-relaxed max-w-2xl mx-auto" data-id="element-57">
          {isFR ? 'Une plateforme qui connecte les personnes, les services et les données. ATNA vérifie, bâtit la confiance et exécute.' : 'One platform that connects people, services and data. ATNA verifies, builds trust and executes.'}
        </motion.p>
      </div>

      {/* Foundation diagram — single responsive image, switches by language */}
      <motion.div {...reveal} transition={{
      duration: 0.7,
      delay: 0.15
    }} className="max-w-6xl mx-auto" data-id="element-58">
        <img src={isFR ? 'https://cdn.magicpatterns.com/uploads/uC7qXLRGp2csiafw5ax3qn/ChatGPT_Image_7_juil._2026,_11_43_47.png' : 'https://cdn.magicpatterns.com/uploads/nbbLkrwTBAN5KQX1LEUsS5/ChatGPT_Image_7_juil._2026,_11_44_07.png'} alt={isFR ? "Schéma BCITI : points d'accès, identité vérifiée, services connectés et expérience administrative, reliés par ATNA — Vérifie, Recommande, Exécute." : 'BCITI diagram: access points, verified identity, connected services and administrative experience, linked by ATNA — Verify, Recommend, Execute.'} className="w-full h-auto object-contain" data-id="element-59" />
      </motion.div>

      {/* Closing line — loops back to the Section 2 question */}
      <motion.div {...reveal} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="max-w-3xl mx-auto text-center mt-20" data-id="element-60">
        <p className="font-serif text-2xl md:text-3xl text-[#121212] leading-snug" data-id="element-61">
          {isFR ? <>
              BCITI + ATNA augmentent la{' '}
              <span className="text-[#4F46E5]" data-id="element-62">capacité</span> — pas la
              complexité.
            </> : <>
              BCITI + ATNA increase{' '}
              <span className="text-[#4F46E5]" data-id="element-63">capacity</span> — not complexity.
            </>}
        </p>
      </motion.div>
    </section>;
}